/*
interface SISTEMA_PERMISSOES_INTERFACE {
  [key: string]: {
    MODULO: string
    PERMISSOES: {
      [key: string]: string
      // EXCLUIR: string,

    }
  }
}
*/


// TODO - Criar Novo Crud
export interface SISTEMA_PERMISSOES_INTERFACE {

  AMOSTRASREFERENCIA: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  ANALISES: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  CLIENTES: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  CONDICOESPAGAMENTOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  EQUIPAMENTOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  FILIAIS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  GRUPOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  LAUDO: {
    MODULO: string
    PERMISSOES: {
      REVISAR: string
      CONSULTAR: string
      EMISSAO: string
      REEMISSAO: string
      DOWNLOAD: string
    }
  }

  LEITURA: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  MAPAPRODUCAO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
      CONSULTAR: string
      DIGITARRESULTADOS: string
      PREPARARMAPASPRODUCAO: string
    }
  }

  MATERIAIS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  ORDENSDESERVICOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
      ALTERAR_STATUS_NO_CADASTRO: string
      RECEBER_ORDENS_SERVICOS: string
    }
  }

  PARAMETRO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  PARAMETROLEITURALABORATORIO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  PRODUTOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  PROPRIEDADES: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  SETORPRODUCAO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  TABELAPRECOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  TIPOMAPAPRODUCAO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  USUARIOS: {
    MODULO: string
    PERMISSOES: {
      USUARIOS_GLOBAIS: string
      CADASTRO_USUARIO_FILIAL: string
    }
  }
}

export const MAXIMO_ERRO_LOGIN: number = 3

export const SISTEMA_PERMISSOES: SISTEMA_PERMISSOES_INTERFACE = {
  AMOSTRASREFERENCIA: {
    MODULO: 'Cadastro de Amostras de Referência',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Amostras de Referência'
    }
  },

  ANALISES: {
    MODULO: 'Cadastro de Análises',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Análises'
    }
  },

  CLIENTES: {
    MODULO: 'Cadastro de Clientes',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Clientes'
    }
  },

  CONDICOESPAGAMENTOS: {
    MODULO: 'Cadastro de Condições de Pagamentos',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Condições de Pagamentos'
    }
  },

  EQUIPAMENTOS: {
    MODULO: 'Cadastro de Equipamentos',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Equipamentos'
    }
  },

  FILIAIS: {
    MODULO: 'Cadastro de Filiais',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Filiais'
    }
  },

  GRUPOS: {
    MODULO: 'Cadastro de Grupos de Usuários',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Grupos'
    }
  },

  LAUDO: {
    MODULO: 'Laudos de Análises',
    PERMISSOES: {
      CONSULTAR: 'Consultar Laudos',
      REVISAR: 'Revisar Lotes / Resultados',
      EMISSAO: 'Emitir Laudos',
      REEMISSAO: 'Reemitir Laudos',
      DOWNLOAD: 'Consultar e Imprimir Laudos'
    }
  },

  LEITURA: {
    MODULO: 'Leitura de Resultado',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Leituras de Resultados'
    }
  },

  MAPAPRODUCAO: {
    MODULO: 'Mapa de Produção',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Mapas de Produção',
      CONSULTAR: 'Consultar Mapas de Produção',
      DIGITARRESULTADOS: 'Realizar Leituras de Amostras',
      PREPARARMAPASPRODUCAO: 'Preparar Mapas de Produção para Leitura'
    }
  },

  MATERIAIS: {
    MODULO: 'Cadastro de Materiais',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Materiais'
    }
  },

  ORDENSDESERVICOS: {
    MODULO: 'Cadastro de Ordens de Serviços',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Ordens de Serviços',
      ALTERAR_STATUS_NO_CADASTRO: 'Alterar Status de Ordens de Serviços no Cadastro',
      RECEBER_ORDENS_SERVICOS: 'Receber OSs que estão em trânsito'
    }
  },

  PARAMETRO: {
    MODULO: 'Parâmetros Gerais do Sistema',
    PERMISSOES: {
      MANUTENCAO: 'Aleração dos Parâmetros'
    }
  },

  PARAMETROLEITURALABORATORIO: {
    MODULO: 'Cadastro de Parâmetros de Leitura de Laboratório',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Parâmetros de Leitura de Laboratório'
    }
  },

  PRODUTOS: {
    MODULO: 'Cadastro de Produtos',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Produtos'
    }
  },

  PROPRIEDADES: {
    MODULO: 'Cadastro de Propriedades',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Propriedades'
    }
  },

  SETORPRODUCAO: {
    MODULO: 'Setor de Produção',
    PERMISSOES: {
      MANUTENCAO: 'Cadastro de Setor de Produção'
    }
  },

  TABELAPRECOS: {
    MODULO: 'Tabela de Preços',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Tabelas de Precos'
    }
  },

  TIPOMAPAPRODUCAO: {
    MODULO: 'Tipos de Mapa de Produção',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Tipos de Mapas de Produção'
    }
  },

  USUARIOS: {
    MODULO: 'Cadastro de Usuário',
    PERMISSOES: {
      USUARIOS_GLOBAIS: 'Manutenção de Usuários Globais',
      CADASTRO_USUARIO_FILIAL: 'Manutenção de Usuários da Filial'
    }
  }
}
